import { FindContentStrategyEnum, PublishStatusEnum } from 'lingo2-models';
import { IContentTab } from './models';

export const tabs: IContentTab[] = [
  {
    id: 'all',
    title: 'content.tabs-all',
    stub: '??',
    stub_guest: '??',
    filter: {
      use: FindContentStrategyEnum.owned,
      publish_status: [
        PublishStatusEnum.published,
        PublishStatusEnum.private,
        PublishStatusEnum.draft,
        PublishStatusEnum.moderation,
      ],
    },
  },
  {
    id: 'published',
    title: 'publish-status.published',
    stub: '??',
    stub_guest: '??',
    filter: {
      use: FindContentStrategyEnum.owned,
      publish_status: [PublishStatusEnum.published],
    },
  },
  {
    id: 'private',
    title: 'publish-status.private',
    stub: '??',
    stub_guest: '??',
    filter: {
      use: FindContentStrategyEnum.owned,
      publish_status: [PublishStatusEnum.private],
    },
  },
  {
    id: 'draft',
    title: 'publish-status.draft',
    stub: '??',
    stub_guest: '??',
    filter: {
      use: FindContentStrategyEnum.owned,
      publish_status: [PublishStatusEnum.draft],
    },
  },
  {
    id: 'moderation',
    title: 'publish-status.moderation',
    stub: '??',
    stub_guest: '??',
    filter: {
      use: FindContentStrategyEnum.owned,
      publish_status: [PublishStatusEnum.moderation],
    },
  },
  {
    id: 'archive',
    title: 'publish-status.archive',
    stub: '??',
    stub_guest: '??',
    filter: {
      use: FindContentStrategyEnum.owned,
      publish_status: [PublishStatusEnum.archive],
    },
  },
];
export const statusAlerts = [
  {
    action: 'unpublish-public',
    title: 'my-library.alerts.unpublish.title',
    text: 'my-library.alerts.unpublish.text',
    submit: 'my-library.alerts.actions.unpublish',
    cancel: 'my-library.alerts.actions.dont-unpublish',
  },
  {
    action: 'archive-public',
    title: 'my-library.alerts.archive-public.title',
    text: 'my-library.alerts.archive-public.text',
    submit: 'my-library.alerts.actions.send-to-archive',
    cancel: 'my-library.alerts.actions.dont-send',
  },
  {
    action: 'archive-private',
    title: 'my-library.alerts.archive-private.title',
    text: 'my-library.alerts.archive-private.text',
    submit: 'my-library.alerts.actions.send-to-archive',
    cancel: 'my-library.alerts.actions.dont-send',
  },
  {
    action: 'archive-draft',
    title: 'my-library.alerts.archive-draft.title',
    text: 'my-library.alerts.archive-draft.text',
    submit: 'my-library.alerts.actions.send-to-archive',
    cancel: 'my-library.alerts.actions.dont-send',
  },
  {
    action: 'edit-public',
    title: 'my-library.alerts.edit-public.title',
    text: 'my-library.alerts.edit-public.text',
    submit: 'my-library.alerts.actions.go-to-editor',
    cancel: 'my-library.alerts.actions.stay',
  },
  {
    action: 'edit-private',
    title: 'my-library.alerts.edit-private.title',
    text: 'my-library.alerts.edit-private.text',
    submit: 'my-library.alerts.actions.go-to-editor',
    cancel: 'my-library.alerts.actions.stay',
  },
  {
    action: 'edit-draft',
    title: 'my-library.alerts.edit-draft.title',
    text: 'my-library.alerts.edit-draft.text',
    submit: 'my-library.alerts.actions.go-to-editor',
    cancel: 'my-library.alerts.actions.stay',
  },
  {
    action: 'restore-archive',
    title: 'my-library.alerts.restore-archive.title',
    text: 'my-library.alerts.restore-archive.text',
    submit: 'my-library.alerts.actions.restore',
    cancel: 'my-library.alerts.actions.dont-restore',
  },
];
